import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import domReady from '@wordpress/dom-ready';

domReady(() => {
  Fancybox.bind('.recipe-floating-container__play-btn', {
    defaultType: 'video',
  });

  const pageContainer = document.querySelector('.single-recipe-container');
  const popupAllCta = pageContainer.querySelectorAll('#rate-my-post-cta');
  const rmpPopup = pageContainer.querySelector('.rmp-widgets-container');
  if (0 < popupAllCta.length) {
    popupAllCta.forEach((popupCta) => {
      popupCta.addEventListener('click', function () {
        rmpPopup.classList.toggle('opened-rmp-popup');
        document.body.classList.toggle('opened-popup');
      });
    });
  }
});
